module.exports = __webpack_public_path__ + "static/media/zelle.4d677244.png";